import { Controller } from '@hotwired/stimulus';

export default class CurrencyToggleController extends Controller {
  static targets = ['eurValue', 'chfValue', 'eurButton', 'chfButton']
  static values = { currency: String }

  select(event) {
    this.currencyValue = event.params.currency
  }

  currencyValueChanged() {
    const isEur = this.currencyValue === 'eur'

    this.eurValueTargets.forEach((el) => el.classList.toggle('d-none', !isEur))
    this.chfValueTargets.forEach((el) => el.classList.toggle('d-none', isEur))

    this.eurButtonTarget.classList.toggle('bg-primary-200', isEur)
    this.eurButtonTarget.classList.toggle('text-primary-950', isEur)
    this.eurButtonTarget.classList.toggle('fw-bold', isEur)
    this.eurButtonTarget.classList.toggle('text-primary-700', !isEur)

    this.chfButtonTarget.classList.toggle('bg-primary-200', !isEur)
    this.chfButtonTarget.classList.toggle('text-primary-950', !isEur)
    this.chfButtonTarget.classList.toggle('fw-bold', !isEur)
    this.chfButtonTarget.classList.toggle('text-primary-700', isEur)
  }
}
